import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.1_rollup@4.40.2_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/pages/runtime/validate.js";
import test_45global from "/opt/buildhome/repo/middleware/test.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.1_rollup@4.40.2_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  test_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "middleware-1": () => import("/opt/buildhome/repo/middleware/middleware-1.ts")
}